import { FC, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Button, Modal, Row, Typography } from "antd";
import {
  DocumentLoaderWrapper,
  GlobalModalStyles,
  PdfWrapper,
  Wrapper,
} from "./styled";
import { ArrowLeftRoundedIcon, ArrowRightRoundedIcon } from "../../components/icons";
import { TDocument } from "../../types";
import { Loader } from "../Loader/Loader";
// import { dowloadDocumentPdf } from "services";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface IPdfModalViewerProps {
  clearDocument: () => void;
  document: TDocument | null;
}

export const PdfModalViewer: FC<IPdfModalViewerProps> = ({
  clearDocument,
  document,
}) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = (props: any) => {
    const { numPages: totalPages } = props;
    setNumPages(totalPages);
  };

  const goToPreviousPage = () => {
    if (pageNumber === 1 && numPages) {
      setPageNumber(numPages);
    } else {
      setPageNumber(pageNumber - 1);
    }
  };

  const goToNextPage = () => {
    if (pageNumber === numPages) {
      setPageNumber(1);
    } else {
      setPageNumber(pageNumber + 1);
    }
  };

  const onClose = () => {
    clearDocument();
    setNumPages(null);
  };

  if (!document?.fileBimUri) return null;

  return (
    <>
      <GlobalModalStyles />

      <Modal
        className="pdf-modal"
        title={document?.name}
        // visible={!!document}
        onCancel={onClose}
        footer={null}
      >
        <Wrapper>
          <Row justify="end">
            {numPages && (
              <Button
                onClick={() => {}
                  //  dowloadDocumentPdf(document)
                }
                type="primary"
              >
                Скачать файл
              </Button>
            )}
          </Row>

          <PdfWrapper align="middle" justify="center" wrap={false}>
            {numPages && <ArrowLeftRoundedIcon onClick={goToPreviousPage} />}

            <Document
              file={{
                httpHeaders: { "Content-Type": "application/pdf" },
                url: document.fileBimUri,
                withCredentials: true,
              }}
              onLoadSuccess={onDocumentLoadSuccess}
              loading={
                <DocumentLoaderWrapper>
                  <Loader />
                </DocumentLoaderWrapper>
              }
              noData={<Typography.Text>Нет данных</Typography.Text>}
              error={<Typography.Text>Не удалось загрузить данные</Typography.Text>}
            >
              <Page pageNumber={pageNumber} scale={0.958} />
            </Document>

            {numPages && <ArrowRightRoundedIcon onClick={goToNextPage} />}
          </PdfWrapper>
        </Wrapper>
      </Modal>
    </>
  );
};
